import { useState, useCallback,useEffect } from "react";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "./ImageCropperHelper"; // helper to get cropped image blob

const ImageCropper = ({ imageSrc, onClose, onCropComplete }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(0.5);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    // Reset crop and zoom every time a new imageSrc is provided
  useEffect(() => {
    setCrop({ x: 0, y: 0 });
    setZoom(1);
  }, [imageSrc]);

  const onCropCompleteInternal = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCropConfirm = async () => {
    try {
      const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
      onCropComplete(croppedImageBlob);
      onClose();
    } catch (error) {
      console.error("Crop failed:", error);
    }
  };

  return (
    <div
      className="modal-backdrop"
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1050,
      }}
    >
      <div
        style={{
          width: "90vw",
          maxWidth: 600,
          backgroundColor: "white",
          padding: 20,
          borderRadius: 8,
          position: "relative",
        }}
      >
        <h5 className="mb-3">Crop Image</h5>
        <div style={{ position: "relative", width: "100%", height: 600, background: "#333" }}>
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={1/ 1}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropCompleteInternal}
            cropShape="rect"
            showGrid={true}
          />
      </div>

       {/* Zoom Slider */}
        <div className="mt-3">
          <label htmlFor="zoomRange" className="form-label">Use mouse scroll or Slide to Zoom: {zoom.toFixed(2)}</label>
          <input
            type="range"
            id="zoomRange"
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e) => setZoom(Number(e.target.value))}
            className="form-range"
          />
        </div>

        <div className="mt-3 d-flex justify-content-between">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={handleCropConfirm}>Crop & Save</button>
        </div>
      </div>
    </div>
  );
};

export default ImageCropper;
